import React, { useContext } from 'react';
import {
  shape, string, useDataModel, params, arrayOf, number, bool
} from '@thd-nucleus/data-sources';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { useNavigate, useLocation } from '@thd-olt-component-react/router';
import { ResultsPagination } from '../components/ResultsPagination';
import { ProductResultsSearchMethodsPLP } from '../utils/product-results-search-methods-PLP';
import { useResultsRefUpdate } from '../hooks/useResultsRefUpdate';

const ResultsPaginationComposable = () => {
  const ctx = useContext(ExperienceContext);
  const { pathname, search } = useLocation();
  const path = `${pathname}${search}`;
  const { customContext } = ctx;
  const variables = { ...(customContext?.variables || {}) };
  const pageSize = customContext?.variables?.pageSize;
  const resultsDimensionsRef = useResultsRefUpdate();
  const navigate = useNavigate();
  const onPageChangePLP = ProductResultsSearchMethodsPLP().onPageChangePLP;

  const defaultOptions = {
    variables: {
      ...variables
    },
    ssr: true,
    skip: !variables.navParam && !variables.keyword,
  };

  const { data = {} } = useDataModel('searchModel', defaultOptions);

  const { metadata } = data?.searchModel || {};
  const { contentType } = metadata || {};
  const isCategory = contentType === 'categorypage';

  if (isCategory) {
    return null;
  }

  return (
    <div className="grid sui-pt-4 sui-pb-4">
      <div className="sui-w-full">
        <ResultsPagination
          onPageChange={({ url }) => onPageChangePLP({ url, resultsDimensionsRef, navigate })}
          pageSize={pageSize}
          path={path}
          data={data}
        />
      </div>
    </div>
  );
};

ResultsPaginationComposable.dataModel = {
  searchModel: params({ keyword: string(), navParam: string(), storeId: string() }).shape({
    metadata: shape({
      canonicalUrl: string(),
      clearAllRefinementsURL: string(),
      contentType: string(),
      h1Tag: string(),
      isStoreDisplay: string(),
      productCount: shape({
        inStore: string(),
      }),
    }),
    products: arrayOf(shape({
      itemId: string(),
    })),
    searchReport: shape({
      keyword: string(),
      sortBy: string(),
      sortOrder: string(),
      totalProducts: number(),
    }),
    appliedDimensions: arrayOf(
      shape({
        label: string(),
        isNumericFilter: bool(),
        refinements: arrayOf(
          shape({
            label: string(),
            refinementKey: string(),
          })
        ),
      })
    ),
  }),
};

ResultsPaginationComposable.displayName = "ResultsPaginationComposable";

export { ResultsPaginationComposable };
